import { render, staticRenderFns } from "./search-comp.vue?vue&type=template&id=57011837&scoped=true&"
import script from "./search-comp.vue?vue&type=script&lang=js&"
export * from "./search-comp.vue?vue&type=script&lang=js&"
import style0 from "./search-comp.vue?vue&type=style&index=0&id=57011837&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57011837",
  null
  
)

export default component.exports